import { useFindAssetIdForWorkspace } from '@gripp/shared-logic';
import { LoadingIndicator, SlideAction, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { AssetCard } from '../../assets/components/assetCard';
import { AssetFilters } from '../../assets/components/assetFilters';
import { Workspaces } from './workspaces';

export const WorkspaceDetail = () => {
  const { workspaceId = '' } = useParams();
  const navigate = useNavigate();
  const { assetId, isLoading } = useFindAssetIdForWorkspace(workspaceId);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!assetId) {
    return null;
  }

  const routeContext = {
    basePath: `/workspaces/${workspaceId}`,
    listPath: '/workspaces',
    isWorkspaceMode: true,
  };

  const rightColumn = {
    title: 'admin.menu.workspaces',
    mainComponent: (
      <AssetRouteProvider value={routeContext}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ),
    headerComponent: (
      <AssetRouteProvider value={routeContext}>
        <AssetFilters assetId={assetId} />
      </AssetRouteProvider>
    ),
    showBackButton: true,
    backButtonTransition: SlideAction.SINGLE,
    onBackButtonPress: () => {
      navigate('/workspaces');
    },
  };

  return <Workspaces rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};
